import { BookHeart } from "lucide-react";

import type { ManualTriState } from "@/api/db/manuals";
import { ManualLabels } from "@/lib/labels/manuals";
import { cn } from "@/lib/utils";

const TONE_CLASS: Record<ManualTriState, string> = {
	draft: "text-muted-foreground",
	delivered_not_opened: "text-muted-foreground",
	opened: "text-whatsapp",
};

export function ManualStatusIcon({ status }: { status: ManualTriState | null | undefined }) {
	if (!status) {
		return null;
	}

	const label = ManualLabels.triStateIcon[status];

	return (
		<span
			data-slot="manual"
			data-status={status}
			className="inline-flex shrink-0 items-center gap-1 text-xs font-medium text-muted-foreground"
		>
			<BookHeart className={cn("size-3.5 shrink-0", TONE_CLASS[status])} />
			{label}
		</span>
	);
}
